<template>
	<div id="editVendorModal" style="display: block" class="modal" role="dialog">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<div>
						<h3 class="uptext">Edit Vendor</h3>
					</div>
				</div>
				<div class="modal-body">
					<div class="block inputCell email">
						<label>Name</label>
						<div class="input placeholder">
							<input
								v-model="vendorName"
								type="text"
								class="form-control"
								placeholder="Edit Vendor"
								v-on:keyup.enter="updateVendor(vendorName)"
							/>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div>
						<b-button class="btn-default btnSize" @click="$emit('close')"
							>Cancel</b-button
						>
					</div>
					<div>
						<b-button
							class="btnSize"
							variant="success"
							type="submit"
							@click="updateVendor(vendorName)"
							>Done</b-button
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { getUserId } from "../utils/auth";

export default {
	name: "EditVendor",
	props: ["passParam"],
	data() {
		return {
			fullPage: false,
			isLoading: false,
			oldVendorName: this.passParam,
			vendorName: this.passParam,
			sendData: {}
		};
	},
	components: {
		Loading
	},
	methods: {
		updateVendor(name) {
			const self = this;
			self.isLoading = true;
			let userId = getUserId();
			this.sendData = {
				user_id: userId,
				attribute_type: "vendor",
				old_attribute_name: this.oldVendorName,
				new_attribute_name: name
			};
			let params = this.sendData;
			this.$axios.post("attributes", params, { crossdomain: true }).then(
				response => {
					if (response.status === 200) {
						this.$store.dispatch("loadAttribute").finally(() => {
							self.isLoading = false;
							this.$emit("close");
						});
					}
				},
				err => {
					console.log(err);
				}
			);
		}
	}
};
</script>
